var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "module-content" }, [
    _c("div", { staticClass: "module-header" }, [
      _c("div", { staticClass: "left" }, [
        _c("h2", [_vm._v("Supporters")]),
        _c("i", {
          staticClass: "icn icn-refresh mr-2 text-primary-500 refresh",
          attrs: { title: "Refresh list" },
          on: {
            click: function($event) {
              return _vm.fetchSupporters()
            }
          }
        })
      ]),
      _vm._m(0)
    ]),
    _vm.isLoading
      ? _c("div", { staticClass: "container w-max" }, [_vm._m(1)])
      : _vm._e(),
    !_vm.isLoading
      ? _c("div", { staticClass: "container" }, [
          _c(
            "div",
            { staticClass: "table-wrapper" },
            [
              _c("Table", {
                attrs: {
                  items: _vm.filterItems,
                  attributes: _vm.tableAttributes,
                  options: _vm.tableOptions
                },
                on: { edit: _vm.viewSupporter }
              })
            ],
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "flex flex-row bg-primary-100 items-center rounded" },
      [
        _c(
          "div",
          {
            staticClass:
              "flex items-center mr-2 bg-primary-500 py-2 px-2 rounded-l text-white"
          },
          [_c("i", { staticClass: "icn icn-information-circle" })]
        ),
        _c("div", { staticClass: "py-2 pr-2 text-primary-500" }, [
          _vm._v("Displaying top 100 recently active supporters.")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex flex-col items-center" }, [
      _c("img", {
        staticClass: "h-36 mt-20",
        attrs: { src: require("@/assets/img/loading.svg") }
      }),
      _c("h2", [_vm._v("Fetching supporter")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }